import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "id", "isChecked", "isDefaultChecked", "isDefaultIndeterminate", "isDisabled", "isInline", "isIndeterminate", "isInvalid", "mode", "size", "name", "onChange"];
import { forwardRef, useEffect, useRef } from 'react';
import cx from 'classnames';
import { ThemeProvider } from 'styled-components';
import { prefix } from '../../tools/settings';
import { Styled } from './Checkbox.styled';
import { jsx as _jsx } from "react/jsx-runtime";
var Checkbox = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      customClassName = _ref.className,
      id = _ref.id,
      _ref$isChecked = _ref.isChecked,
      isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
      isDefaultChecked = _ref.isDefaultChecked,
      isDefaultIndeterminate = _ref.isDefaultIndeterminate,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInline = _ref.isInline,
      isInline = _ref$isInline === void 0 ? false : _ref$isInline,
      isIndeterminate = _ref.isIndeterminate,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      name = _ref.name,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-checkbox"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var inputRef = useRef(null);

  var inputRefCallback = function inputRefCallback(ref) {
    inputRef.current = ref;
  };

  useEffect(function () {
    if (isChecked) {
      inputRef.current.setAttribute('checked', '');
    }

    if (!isChecked || isIndeterminate) {
      inputRef.current.removeAttribute('checked', '');
    }
  }, [isChecked, isIndeterminate]);
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(Styled.CheckboxContainer, {
      ref: ref,
      className: className,
      isInline: isInline,
      children: _jsx(Styled.Checkbox, {
        inputRef: inputRefCallback,
        disabled: isDisabled,
        checked: isChecked,
        invalid: isInvalid ? 'invalid' : undefined,
        inline: true,
        onChange: onChange,
        defaultChecked: isDefaultChecked,
        defaultIndeterminate: isDefaultIndeterminate,
        indeterminate: isIndeterminate,
        id: id,
        name: name,
        children: children && _jsx(Styled.CheckboxContent, {
          children: children
        })
      })
    })
  });
});
export default Checkbox;